import { render } from "./InviteBanner.vue?vue&type=template&id=c3bcf870&scoped=true"
import script from "./InviteBanner.vue?vue&type=script&lang=js"
export * from "./InviteBanner.vue?vue&type=script&lang=js"

import "./InviteBanner.vue?vue&type=style&index=0&id=c3bcf870&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3bcf870"]])

export default __exports__